<template>
  <div class="myaccount-details">
      <form action="#" class="uren-form">
        <div class="uren-form-inner">
          <div class="single-input single-input-half">
            <input v-model="firstName" type="text" id="account-details-firstname" placeholder="First Name" required>
          </div>
          <div class="single-input single-input-half">
            <input v-model="lastName" type="text" id="account-details-lastname" placeholder="Last Name" required>
          </div>
          <div class="single-input">
            <input v-model="email" type="email" id="account-details-email" placeholder="Email" required>
          </div>
          <div class="single-input">
            <input v-model="password" type="password" id="account-details-oldpass"
              placeholder="Current Password(leave blank to leave unchanged)" required>
          </div>
          <div class="single-input">
            <input v-model="newPassword" type="password" id="account-details-newpass"
              placeholder="New Password (leave blank to leave unchanged)" required>
          </div>
          <div class="single-input">
            <input v-model="confirmPassword" type="password" id="account-details-confpass" placeholder="Confirm New Password"
              required>
          </div>
          <div class="single-input">
            <button class="uren-btn uren-btn_dark" type="submit"><span>SAVE CHANGES</span></button>
          </div>
        </div>
      </form>
    </div>
</template>

<script>
export default {
  name: "AccountDetails",
  data() {
    return {
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      newPassword: '',
      confirmPassword: '',
    }
  }
}
</script>

<style>

</style>
